const apiconfig =  {
  "api_url": "https://entry.universal-field.com/api/api_ufentry.php",
  "stgapi_url": "https://entry.universal-field.com/stg/api/api_ufentry.php",

  "reservation_url": "https://reserve.universal-field.com",
  "stgreservation_url": "https://staging-reserve.universal-field.com",

  "connect_url": "https://connect.universal-field.com/reservecategory.html",
  "stgconnect_url": "https://staging-reserve.universal-field.com/",

};
export default apiconfig;